import { useMutation, useQueryClient } from "@tanstack/react-query";
import { makeApiRequest } from "../../utils";
import {
  CARBON_OFFSET_CONTRACTS_QUERY_KEY,
  CARBON_OFFSET_SUPPLIERS_QUERY_KEY,
  CARBON_OFFSET_PROJECTS_QUERY_KEY,
  CARBON_OFFSET_INVENTORY_POOLS_QUERY_KEY,
  CARBON_OFFSET_PORTFOLIOS_QUERY_KEY,
  CARBON_OFFSET_CLIENTS_QUERY_KEY
} from "../../../constants/queryKeys";

export const useCreateContract = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (data) => {
      return makeApiRequest({
        endpoint: "/api/carbon_offset/contracts",
        method: "POST",
        body: data,
        json: true
      });
    },
    onSuccess: () => {
      queryClient.invalidateQueries([CARBON_OFFSET_CONTRACTS_QUERY_KEY]);
    }
  });
};

export const useUpdateContract = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async ({ id, data }) => {
      return makeApiRequest({
        endpoint: `/api/carbon_offset/contracts/${id}`,
        method: "PUT",
        body: data,
        json: true
      });
    },
    onSuccess: () => {
      queryClient.invalidateQueries([CARBON_OFFSET_CONTRACTS_QUERY_KEY]);
      queryClient.invalidateQueries([CARBON_OFFSET_PORTFOLIOS_QUERY_KEY]);
    }
  });
};

export const useCreateSupplier = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (data) => {
      return makeApiRequest({
        endpoint: "/api/carbon_offset/suppliers",
        method: "POST",
        body: data,
        json: true
      });
    },
    onSuccess: () => {
      queryClient.invalidateQueries([CARBON_OFFSET_SUPPLIERS_QUERY_KEY]);
    }
  });
};

export const useCreateProject = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (data) => {
      return makeApiRequest({
        endpoint: "/api/carbon_offset/projects",
        method: "POST",
        body: data,
        json: true
      });
    },
    onSuccess: () => {
      queryClient.invalidateQueries([CARBON_OFFSET_PROJECTS_QUERY_KEY]);
    }
  });
};

export const useCreatePortfolio = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (data) => {
      return makeApiRequest({
        endpoint: "/api/carbon_offset/portfolios",
        method: "POST",
        body: data,
        json: true
      });
    },
    onSuccess: () => {
      queryClient.invalidateQueries([CARBON_OFFSET_PORTFOLIOS_QUERY_KEY]);
    }
  });
};

export const useUpdatePortfolioMix = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async ({ id, data }) => {
      return makeApiRequest({
        endpoint: `/api/carbon_offset/portfolios/${id}/mix`,
        method: "PUT",
        body: data,
        json: true
      });
    },
    onSuccess: () => {
      queryClient.invalidateQueries([CARBON_OFFSET_PORTFOLIOS_QUERY_KEY]);
    }
  });
};

export const useUpdatePortfolioPrice = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async ({ id, data }) => {
      return makeApiRequest({
        endpoint: `/api/carbon_offset/portfolios/${id}/price`,
        method: "PUT",
        body: data,
        json: true
      });
    },
    onSuccess: () => {
      queryClient.invalidateQueries([CARBON_OFFSET_PORTFOLIOS_QUERY_KEY]);
    }
  });
};

export const useAddPortfolioClients = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async ({ id, clients }) => {
      return makeApiRequest({
        endpoint: `/api/carbon_offset/portfolios/${id}/clients`,
        method: "POST",
        body: { clients },
        json: true
      });
    },
    onSuccess: () => {
      queryClient.invalidateQueries([CARBON_OFFSET_PORTFOLIOS_QUERY_KEY]);
    }
  });
};

export const useCreateInventoryPool = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (data) => {
      return makeApiRequest({
        endpoint: "/api/carbon_offset/inventory_pools",
        method: "POST",
        body: data,
        json: true
      });
    },
    onSuccess: () => {
      queryClient.invalidateQueries([CARBON_OFFSET_INVENTORY_POOLS_QUERY_KEY]);
    }
  });
};

export const useCreateClient = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (data) => {
      return makeApiRequest({
        endpoint: "/api/carbon_offset/clients",
        method: "POST",
        body: data,
        json: true
      });
    },
    onSuccess: () => {
      queryClient.invalidateQueries([CARBON_OFFSET_CLIENTS_QUERY_KEY]);
    }
  });
};

export const useVoidContract = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (id) => {
      return makeApiRequest({
        endpoint: `/api/carbon_offset/contracts/${id}/void`,
        method: "POST",
        json: true
      });
    },
    onSuccess: () => {
      queryClient.invalidateQueries([CARBON_OFFSET_CONTRACTS_QUERY_KEY]);
      queryClient.invalidateQueries([CARBON_OFFSET_PORTFOLIOS_QUERY_KEY]);
    }
  });
};
